// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"190cf8ee","453":"a4f12de5","455":"2ed05ba9","977":"f9f47acf"}[chunkId] + ".chunk.js";
};